// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yZErq2Pc4liX9d {
  position: relative;
  width: 100vw;
  min-width: 375px;
  max-width: 600px;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface, #ffffff);
}
.yZErq2Pc4liX9d .oghiy7qpJUuzFg {
  width: 100%;
  border-radius: var(--ds-border-radius-200, 8px);
}
.yZErq2Pc4liX9d .IUUgW6HdcWYTl6 {
  border-radius: 0;
}
.yZErq2Pc4liX9d .MwRQS33elzJOTN {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--ds-space-400, 32px);
  text-align: center;
}
.yZErq2Pc4liX9d .MwRQS33elzJOTN .jEFFANwOTsfm8A {
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0);
  font-size: 24px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 28px;
}
.yZErq2Pc4liX9d .MwRQS33elzJOTN .cgsF1SoWAHBDv_,
.yZErq2Pc4liX9d .MwRQS33elzJOTN .VaqmGoU8Pn5WWz {
  border: 0;
  font-size: 14px;
  line-height: 20px;
}
.yZErq2Pc4liX9d .MwRQS33elzJOTN .VaqmGoU8Pn5WWz {
  margin-top: var(--ds-space-200, 16px);
  padding: var(--ds-space-0, 0);
  background-color: transparent;
  color: var(--ds-link, #0c66e4);
  text-decoration: none;
}
.yZErq2Pc4liX9d .MwRQS33elzJOTN .USe5Y7BfZ5dgYJ {
  margin-top: var(--ds-space-400, 32px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ReverseTrialModal": `yZErq2Pc4liX9d`,
	"image": `oghiy7qpJUuzFg`,
	"gaImage": `IUUgW6HdcWYTl6`,
	"contentContainer": `MwRQS33elzJOTN`,
	"title": `jEFFANwOTsfm8A`,
	"description": `cgsF1SoWAHBDv_`,
	"trialExtension": `VaqmGoU8Pn5WWz`,
	"ctaButton": `USe5Y7BfZ5dgYJ`
};
export default ___CSS_LOADER_EXPORT___;
